import { render, staticRenderFns } from "./CompanyRelevancy.vue?vue&type=template&id=532664b3&scoped=true"
import script from "./CompanyRelevancy.vue?vue&type=script&lang=js"
export * from "./CompanyRelevancy.vue?vue&type=script&lang=js"
import style0 from "./CompanyRelevancy.vue?vue&type=style&index=0&id=532664b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532664b3",
  null
  
)

export default component.exports